module.exports = __webpack_public_path__ + "static/media/bug.fe1d07f5.svg";